import { Moon, Sun } from 'lucide-react';
import { ThemeProvider, useTheme } from 'next-themes';

export function AppThemeProvider({ children }) {
  return <ThemeProvider attribute="class" storageKey="mbp_theme" defaultTheme="light" enableSystem={false} disableTransitionOnChange>{children}</ThemeProvider>;
}

export function ThemeControl() {
  const { theme, setTheme } = useTheme();
  const dark = theme === 'dark';
  return <div className="theme-toolbar">
    <button type="button" onClick={() => setTheme(dark ? 'light' : 'dark')} aria-label={`Switch to ${dark ? 'light' : 'dark'} mode`} aria-pressed={dark} className="theme-switch" data-testid="theme-toggle">
      {dark ? <Sun aria-hidden="true" size={18} /> : <Moon aria-hidden="true" size={18} />}
      <span>{dark ? 'Light mode' : 'Dark mode'}</span>
    </button>
  </div>;
}
